import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { WIDGET_CONVERTER_TOKEN, WidgetConverter } from './widget.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        widgetFeature: {
          module: () => import('./widget.module').then((m) => m.WidgetModule),
          cmsComponents: ['widget'],
        },
      }
    }),
    {
      provide: WIDGET_CONVERTER_TOKEN,
      useClass: WidgetConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        widget: WIDGET_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class WidgetFeatureModule {}
